import React from "react";

export const ExportPageHeader = () => (
  <div className="tw-flex tw-flex-col tw-gap-2">
    <p className="tw-text-sm tw-text-slate-500">Configure an order export by marketplace account, warehouse, status, and date range.</p>
    <p className="tw-text-xs tw-text-slate-400">Choose a saved format or upload your own CSV/XLSX template.</p>
  </div>
);
